import {useDispatch, useSelector} from 'react-redux';
import {selectDefaultTheme, selectThemeById} from '../../../state/theme/themeSelectors';
import {useEffect} from 'react';
import {loadDefaultTheme, loadThemeByReportId} from '../../../state/theme/themeActions';

export const useRoosterCardTheme = (contextEntityType, contextEntityId) => {

  const dispatch = useDispatch();

  useEffect(() => {
    if (contextEntityType === 'REPORT_VIEW') {
      dispatch(loadThemeByReportId(contextEntityId));
    } else {
      dispatch(loadDefaultTheme());
    }
  }, []);

  const reportTheme = useSelector(state => selectThemeById(state, contextEntityId));
  const defaultTheme = useSelector(state => selectDefaultTheme(state));

  return contextEntityType === 'REPORT_VIEW' ? reportTheme : defaultTheme;
};
